/* TIMESHEET */
Vue.component('timesheet',{
    template:'#timesheet-template',
    data:function(){
        return{
            clients:[],
            users:[],
            brands:[],
            active_client:{
                brands:{},
            },
            active_client_id:-1,
            active_brand:{
                projects:{}
            },
            active_brand_id:-1,
            active_project:{},
            active_project_id:-1,
            active_ticket:{},
            active_ticket_id:-1,
            active_user:{},
            active_user_id:-1,
            project_number:'-1',
            ticket_number:'-1',
            date_start:'',
            date_end:'',
            time_records:[],
            timesheet_chart:[],
            filter_client_name:'',
            filter_brand:'',
            activeProjectNumber:''
        };
    },
    created:function(){
        activeInstance = this;
        // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
        // array is 'year', 'month', 'day', etc
        var month = moment().format('M');
        var year =  moment().format('YYYY');
        console.log(month+' '+year);
        var startDate = moment([year, month - 1]);

        setTimeout(function(){
            $("#ticketsearchfield").attr('autocomplete','off');
            $("#projectsearchfield").attr('autocomplete','off');
            $("#projectnumbersearchfield").attr('autocomplete','off');
            $("#ticketnumbersearchfield").attr('autocomplete','off');
        },1000);

        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu',
                    defaultDate: new Date()

                });
                activeInstance.date_end = moment().format('YYYY-MM-DD');

                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu',
                    defaultDate: startDate
                });
                activeInstance.date_start = startDate.format('YYYY-MM-DD');


                setTimeout(function(){
                    var $table = $('.fixed_header_table');
                    $table.floatThead({
                        top:70
                    });
                },200);

                $('#projectnumbersearchfield').val('');
                $('#ticketnumbersearchfield').val('');

                activeInstance.getClients();
                activeInstance.getUsers();

            });
            document.title = 'Munkaóra riport - ODIN Enterprise Manager';
            $("#page_title").text('MUNKAÓRA RIPORT');
        },300);


        var id = $('#content_wrapper').attr('data-id');
    },
    events: {
        'autocomplete-project:selected': function(data){
            console.log(data);
            activeInstance.active_client_id=data.client_id;
            activeInstance.setActiveClient();
            activeInstance.active_brand_id=data.brand_id;
            activeInstance.setActiveBrand();
            activeInstance.active_project_id = data.id;
            activeInstance.project_number = data.project_number;
            setTimeout(function(){
                $('#projectnumbersearchfield').val(data.project_number);
                activeInstance.setActiveProject();
            },200);

        },
        'autocomplete-ticket:selected': function(data){
            console.log(data);
            activeInstance.project_number = data.project_number;
            activeInstance.active_client_id=data.project.client_id;
            activeInstance.setActiveClient();
            activeInstance.active_brand_id=data.project.brand_id;
            activeInstance.setActiveBrand();
            activeInstance.active_project_id = data.project.id;
            setTimeout(function(){
                activeInstance.setActiveProject();
            },200);
            activeInstance.active_ticket_id = data.id;
            setTimeout(function(){
                activeInstance.setActiveTicket();
                $('#ticketnumbersearchfield').val(data.ticket_number);
                $('#projectnumbersearchfield').val(data.project.project_number);
            },200);

        }
    },
    methods:{
        getClients:function() {
            showLoadingOverlay();
            axios.get(baseURL + '/api/timesheet/clients_detailed')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response.data);
                    activeInstance.clients = response.data;
                });
        },
        getUsers:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/timesheet/users')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response.data);
                    activeInstance.users = response.data;
                });
        },
        setActiveClient:function(){
            $.each(activeInstance.clients,function(index,client){

                if(activeInstance.active_client_id == -1){
                    activeInstance.active_client={};
                    activeInstance.active_brand={};
                    activeInstance.active_brand_id=-1;
                    activeInstance.active_project={};
                    activeInstance.active_project_id=-1;
                    activeInstance.active_ticket_id=-1;
                    activeInstance.active_ticket={};
                    activeInstance.ticket_number = '';
                    activeInstance.project_number='';
                    setTimeout(function(){
                        $('#ticketnumbersearchfield').val('');
                        $('#projectnumbersearchfield').val('');
                        $('#projectsearchfield').val('');
                        $('#ticketsearchfield').val('');

                        $('#projectsearchfield').val('');
                    },150);

                }

                if(client.id == activeInstance.active_client_id){
                    activeInstance.active_client = client;
                }
            });
        },
        setActiveBrand:function(){
            $.each(activeInstance.active_client.brands,function(index,brand){

                if(activeInstance.active_brand_id == -1){
                    activeInstance.active_brand={};
                    activeInstance.active_project={};
                    activeInstance.active_ticket_id=-1;
                    activeInstance.active_ticket={};
                    activeInstance.ticket_number = '';
                    activeInstance.project_number='';
                    activeInstance.active_project_id=-1;
                }

                if(brand.id == activeInstance.active_brand_id){
                    activeInstance.active_brand = brand;
                }

            });
        },
        setActiveProject:function(){
            $.each(activeInstance.active_brand.projects,function(index,project){

                if(activeInstance.active_project_id == -1){
                    activeInstance.active_project={};
                    activeInstance.active_ticket={};
                    activeInstance.active_ticket_id=-1;
                    activeInstance.ticket_number = '';
                    activeInstance.project_number = '';
                    $('#ticketnumbersearchfield').val('');
                    $('#projectnumbersearchfield').val('');
                }
                if(project.id == activeInstance.active_project_id){
                    activeInstance.active_project = project;
                    activeInstance.project_number = project.project_number;
                    activeInstance.active_project_id =  project.id;
                    $('#projectnumbersearchfield').val(project.project_number);
                    $('#ticketnumbersearchfield').val('');
                    setTimeout(function(){
                        $('#project_name').val(project.id);
                    },400);

                }

            });
        },
        setActiveTicket:function(){
            $.each(activeInstance.active_project.tickets,function(ticket_index,ticket){
                if(activeInstance.active_ticket_id == -1){
                    activeInstance.ticket_number = '';
                    activeInstance.active_ticket={};
                    $('#ticketnumbersearchfield').val('');
                }
                if(ticket.id == activeInstance.active_ticket_id){
                    activeInstance.active_ticket = ticket;
                    setTimeout(function(){
                        $('#ticketnumbersearchfield').val(ticket.ticket_number);
                    },200);
                    activeInstance.ticket_number = ticket.ticket_number;
                };

            });
        },
        setActiveUser:function(){

        },
        getClientBrands:function(client){
            activeInstance.brands = client.brands;
        },
        getClientProjects:function(){

        },
        getTimeSheetChart:function(){
            //$project_number,$user_id,$date_start,$date_end
            console.log('fetching timesheet data');
            activeInstance.time_records = {};

            showLoadingOverlay();
            Vue.http.post(baseURL+'/api/getTimeSheetChart', {
                'project_id':activeInstance.active_project_id,
                'ticket_id':activeInstance.active_ticket_id,
                'client_id':activeInstance.active_client_id,
                'brand_id':activeInstance.active_brand_id,
                'user_id':activeInstance.active_user_id,
                'date_start':activeInstance.date_start,
                'date_end':activeInstance.date_end
            }).then(function(response){

                activeInstance.time_records = response.data;
                $('body').LoadingOverlay("hide");

                /*
                setTimeout(function() {
                    var running_footable = FooTable.get(".responsive-table");
                    if (running_footable) {
                        running_footable.destroy();
                    }

                    $('.responsive-table').footable();
                },50);
                */

            }).bind(this);
        },
        exportTimeSheetChart:function(){
            //$project_number,$user_id,$date_start,$date_end
            console.log('fetching timesheet data');
            showLoadingOverlay();
            Vue.http.post(baseURL+'/api/exportTimeSheetChart', {
                'project_id':activeInstance.active_project_id,
                'ticket_id':activeInstance.active_ticket_id,
                'client_id':activeInstance.active_client_id,
                'brand_id':activeInstance.active_brand_id,
                'user_id':activeInstance.active_user_id,
                'date_start':activeInstance.date_start,
                'date_end':activeInstance.date_end
            }).then(function(response){
                $('body').LoadingOverlay("hide");
                console.log(response);
                location.href=(response.data);
            }).bind(this);
        },
        humanize:function(text){
            switch (text) {
                case 'day_off':
                    return 'Szabadság';
                    break;
                case 'sick_leave':
                    return 'Betegszabadság';
                    break;
                case 'unconfirmed':
                    return 'Elbírálás alatt';
                    break;
                case 'confirmed':
                    return 'Jóváhagyott';
                    break;
                case 'rejected':
                    return 'Elutasított';
                    break;
                default:
                    break;
            }
        }
    }
});